export function Brand() {
  return (
    <span className="brand">
      <span className="brand-mark" aria-hidden="true"><span /></span>
      <span>Phrasio</span>
    </span>
  );
}
